import { initGrid } from 'utils/grid/grid';
import {
  fetchSentMessagesList,
  fetchAdministratorsSentMessagesList,
  fetchUserSentMessagesList,
  deleteSentMessages,
} from 'message/actions/sent.actions';
import {
  onMessageSelection,
  toggleSelectAllMessagesPointer,
  clearSelectedMessagesList,
  setSelectAllPointerStatus,
} from 'message/actions/selected-messages.actions';
import { checkAccess } from 'app/actions/app.actions';
import template from './sent-messages-list.html';

const mapStateToThis = ({ session, messages, ui, config }) => {
  const { locale, isAdmin, emailAddress } = session;
  const { sent, sentLoadingStatus: isLoading, selectedMessages } = messages;
  const { pagination } = ui;
  const { defaultPageSizes, sortColumnKey, pageSizeKey, directionKey } = config;
  const { selectedMessagesList, hasAllMessagesSelected } = selectedMessages;

  return {
    locale,
    emailAddress,
    isLoading,
    pagination,
    selectedMessagesList,
    hasAllMessagesSelected,
    pageSizeKey,
    sortColumnKey,
    directionKey,
    isAdmin,
    messages: sent,
    defaultPageSize: defaultPageSizes[2],
  };
};

const mapDispatchToThis = {
  fetchSentMessagesList,
  fetchAdministratorsSentMessagesList,
  fetchUserSentMessagesList,
  checkAccess,
  deleteSentMessages,
  onMessageSelection,
  toggleSelectAllMessagesPointer,
  clearSelectedMessagesList,
  setSelectAllPointerStatus,
};

// eslint-disable-next-line no-undef
@Inject('$state', '$ngRedux', 'messageDefinitionService', 'Notifications')
class SentMessagesListController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.canSeeSelfSentItems = this.checkAccess('message.create');
    this.canSeeAllSentItems = this.checkAccess('message.sent.viewOtherSentItems');
    this.canSeeSendersFilter = this.canSeeSelfSentItems && this.canSeeAllSentItems;
    if (this.canSeeSendersFilter) {
      this.sentBy = this.messageDefinitionService.get('ALL', 'id');
    }
    this.headers = this.getHeaders();
    this.senders = this.getSenders();
    this.search();
  }

  $onDestroy() {
    this.clearSelectedMessagesList();
    this.unsubscribe();
  }

  initGridModel() {
    this.defaultParams = {
      [this.sortColumnKey]: 'inAppMessage.sendDate',
      [this.directionKey]: false,
      [this.pageSizeKey]: this.defaultPageSize,
    };

    switch (true) {
      case this.isAdmin === false:
        this.gridModel = initGrid(this.fetchUserSentMessagesList, this.defaultParams);
        break;
      case this.sentBy === this.messageDefinitionService.get('SELF', 'id'):
        this.gridModel = initGrid(this.fetchSentMessagesList, this.defaultParams);
        break;
      case this.sentBy === this.messageDefinitionService.get('ALL', 'id'):
      case this.canSeeAllSentItems:
        this.gridModel = initGrid(this.fetchAdministratorsSentMessagesList, this.defaultParams);
        break;
      default:
        this.gridModel = initGrid(this.fetchSentMessagesList, this.defaultParams);
    }
  }

  async onDeleteMessage() {
    await this.deleteSentMessages();
    this.Notifications.alertSuccess(this.messageDefinitionService.get('MSGS_DELETE', 'desc'));
    this.search();
  }

  search() {
    this.initGridModel();
    this.gridModel.applyFilters();
  }

  getHeaders() {
    return [
      this.isAdmin
        ? {
            text: this.messageDefinitionService.get('AUTHOR', 'desc'),
            field: 'inAppMessage.authorName',
            sortable: true,
          }
        : {
            text: this.messageDefinitionService.get('RECIPIENT', 'desc'),
            field: 'inAppMessage.recipientName',
            sortable: true,
          },
      {
        text: this.messageDefinitionService.get('SUBJECT_AND_PREVIEW', 'desc'),
        field: 'inAppMessage.subject',
        sortable: true,
      },
      {
        text: this.messageDefinitionService.get('SENT', 'desc'),
        field: 'inAppMessage.sendDate',
        sortable: true,
        textAlignment: 'text-right',
      },
    ];
  }

  getSenders() {
    return [this.messageDefinitionService.get('SELF'), this.messageDefinitionService.get('ALL')];
  }

  viewMessage(id) {
    this.$state.go('message.sent', { id });
  }

  toggleSelectAllMessages() {
    const messagesList = this.messages.filter((message) => this.canBeSelected(message.authorName)).map(({ messageId }) => messageId);
    this.toggleSelectAllMessagesPointer(messagesList);
  }

  selectMessage({ authorName, messageId }) {
    if (!this.canBeSelected(authorName)) return;

    this.onMessageSelection(messageId);
    const hasAllMessagesSelected =
      this.messages.filter((msg) => this.canBeSelected(msg.authorName)).length === this.selectedMessagesList.length;
    this.setSelectAllPointerStatus(hasAllMessagesSelected);
  }

  isSelected(id) {
    return this.selectedMessagesList.includes(id);
  }

  canBeSelected(authorName) {
    return authorName === this.emailAddress;
  }
}

export default class SentMessagesListComponent {
  constructor() {
    this.controller = SentMessagesListController;
    this.template = template;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/message/components/sent-messages-list/sent-messages-list-component.js